module.exports = __webpack_public_path__ + "img/price_time.28b8b1f6.svg";